import { useRef, useState, useEffect, useCallback } from 'react';
import css from './CategoryBar.module.css';

const DEFAULT_CATEGORY_TABS = [
  { label: 'SHOP ALL', value: 'all' },
  { label: 'CLOTHING', value: 'clothing' },
  { label: 'BAGS', value: 'bags' },
  { label: 'JEWELRY', value: 'jewelry' },
  { label: 'SHOES', value: 'shoes' },
  { label: 'ACCESSORIES', value: 'accessories' },
];

const CategoryBar = ({
  activeCategory,
  onCategoryChange,
  categories = DEFAULT_CATEGORY_TABS,
  leadingContent = null,
  children = null,
  contentClassName = '',
}) => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = useCallback(() => {
    const element = scrollRef.current;
    if (element) {
      setCanScrollLeft(element.scrollLeft > 0);
      setCanScrollRight(element.scrollLeft < element.scrollWidth - element.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, [checkScroll]);

  const hasCustomContent = Boolean(children);

  return (
    <div className={css.wrapper}>
      <div className={css.container} ref={scrollRef} onScroll={checkScroll}>
        <div
          className={`${css.inner} ${hasCustomContent ? css.innerCustom : ''} ${contentClassName}`}
        >
          {hasCustomContent ? (
            children
          ) : (
            <>
              {leadingContent ? <div className={css.leadingContent}>{leadingContent}</div> : null}
              {categories.map(category => (
                <button
                  key={category.value}
                  className={`${css.category} ${
                    activeCategory === category.value ? css.active : ''
                  }`}
                  type="button"
                  onClick={() => onCategoryChange(category.value)}
                >
                  {category.label}
                </button>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryBar;
